import React from "react";
import { Menu, Button } from "@chakra-ui/react";

export const ISSUE_TYPE_OPTIONS = [
  { value: "PLUMBING", label: "Plumbing" },
  { value: "ELECTRICAL", label: "Electrical" },
  { value: "HVAC", label: "HVAC" },
  { value: "STRUCTURAL", label: "Structural" },
  { value: "APPLIANCE", label: "Appliance" },
  { value: "PEST_CONTROL", label: "Pest Control" },
  { value: "OTHER", label: "Other" },
];

export function IssueTypeSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const selected = ISSUE_TYPE_OPTIONS.find((opt) => opt.value === value);
  return (
    <Menu.Root onSelect={(details) => onChange(details.value)}>
      <Menu.Trigger asChild>
        <Button variant='outline' width='100%' justifyContent='space-between'>
          {selected ? selected.label : "Select issue type"}
          <span>&#9660;</span>
        </Button>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content width='200px'>
          <Menu.ItemGroup>
            {ISSUE_TYPE_OPTIONS.map((opt) => (
              <Menu.Item key={opt.value} value={opt.value}>
                {opt.label}
              </Menu.Item>
            ))}
          </Menu.ItemGroup>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
}
